import React from 'react'

const CadentierStoreSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.0769043" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4674_17915)" />
    <path
      d="M31.842 50.0769C31.842 43.9789 31.842 37.9898 31.842 31.9463C37.8856 31.9463 43.9292 31.9463 50.0272 31.9463C50.0272 32.164 50.0272 32.3818 50.0272 32.5996C50.0272 37.5542 50.0272 42.5089 50.0272 47.5179C50.0272 49.3147 49.2105 50.0769 47.4682 50.0769C42.5135 50.0769 37.5589 50.0769 32.6587 50.0769C32.3321 50.0769 32.1143 50.0769 31.842 50.0769Z"
      fill="white"
    />
    <path
      d="M49.9727 28.5706C39.9545 28.5706 29.9908 28.5706 19.9727 28.5706C19.9727 27.4816 19.9727 26.3927 19.9727 25.3582C19.9727 24.3237 19.9727 23.3437 19.9727 22.3092C19.9727 21.0025 20.8982 20.0769 22.205 20.0769C30.7531 20.0769 39.2467 20.0769 47.7948 20.0769C48.9926 20.0769 49.8638 20.8936 49.9727 21.9825C49.9727 22.1459 49.9727 22.3092 49.9727 22.4725C49.9727 24.4871 49.9727 26.5016 49.9727 28.5706Z"
      fill="white"
    />
    <path
      d="M28.4663 31.9462C28.4663 37.9898 28.4663 43.9789 28.4663 50.0769C27.7585 50.0769 27.1051 50.0769 26.4518 50.0769C25.0362 50.0769 23.6206 50.0769 22.205 50.0769C20.8982 50.0769 19.9727 49.2057 19.9727 47.8446C19.9727 42.6722 19.9727 37.4997 19.9727 32.2729C19.9727 32.164 19.9727 32.0551 20.0271 31.8918C22.8039 31.9462 25.5806 31.9462 28.4663 31.9462Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_17915"
        x1="34.5455"
        y1="0.0769046"
        x2="34.5455"
        y2="70.0769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB300" />
        <stop offset="1" stopColor="#E5A100" />
      </linearGradient>
    </defs>
  </svg>
)

export default CadentierStoreSubcategory
